export default "__VITE_ASSET__20378876__"